<template>
     <el-dialog
     title="创建物料清单"
     :visible.sync="dialogVisible"
     width="500px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="closeDialog"
    >
       <div class="panel">
           <el-form ref="proForm" :model="proForm" :rules="proFormRules" label-width="85px" size="small">
                <el-row :gutter="5">
                    <el-col :span="24">
                        <el-form-item label="父项产品" prop="parentId">
                            <el-select
                                v-model="proForm.parentId"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                            >
                                <el-option
                                v-for="item in productList"
                                :key="item._id"
                                :label="item.productName"
                                :value="item._id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="子项产品" prop="childrenId">
                            <el-select
                                v-model="proForm.childrenId"
                                clearable
                                filterable
                                placeholder="请选择"
                                style="width:100%;"
                            >
                                <el-option
                                v-for="item in productList"
                                :key="item._id"
                                :label="item.productName"
                                :value="item._id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="单位用量" prop="unitUsage">
                            <el-input-number v-model="proForm.unitUsage" controls-position="right"  :min="1" :max="1000" style="width:100%"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remark">
                            <el-input size="small" type="textarea" :rows="2" v-model="proForm.remark" placeholder="输入备注"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
           </el-form>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary" >继续添加子项</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import { materialSave,productGetAll} from '@/api/basicData'
export default {
    name:'createMaterialList',
    props:{
        diaVisible:{
            type:Boolean,
            default:false,
        },
        userData:{
          type:Object,
          default:{},
        },
        mode:{
          type:String,
          default:''
        },
        editRow:{
          type:Object,
          default:{},
        },
    },
    watch:{
        diaVisible(newVal,oldVal){
            if(newVal){
                this.dialogVisible = newVal;
                if(this.mode == 'edit'){
                  this.proForm = JSON.parse(JSON.stringify(this.editRow))
                }
            }
            this.$nextTick(function(){
              if(this.$refs.proForm){
                this.$refs.proForm.clearValidate()
              }
            })
        },
        mode(newVal,oldVal){
          if(this.mode == 'create'){
            this.proForm = {
              parentId:'',
              childrenId:'',
              unitUsage:'',
            }
          }
        }
    },
    data(){
        return{
            dialogVisible: false,
            proForm:{
              parentId:'',
              childrenId:'',
              unitUsage:'',
            },
            proFormRules:{
              parentId: [{
                required: true,
                message: "请选择父项产品",
                trigger: ['blur','change'],
            },] ,
            childrenId: [{
                required: true,
                message: "请选择子项产品",
                trigger: ['blur','change'],
            },] ,
            unitUsage: [{
                required: true,
                message: "请输入单位用量",
                trigger: ['blur','change'],
            },] ,
            },
            productList:[],
        }
    },
    created(){
      this.productAll()
    },
    methods:{
      productAll(){
        productGetAll(this.userData.factoryId).then(res => {
          if(res.code == 200){
            this.productList = res.data
          }else{
            this.$message.error('查询失败！')
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
      },
      handleSave(){
        this.$refs.proForm.validate((valid) => {
            if (valid) {
              var data = JSON.parse(JSON.stringify(this.proForm))
              data.factoryId = this.userData.factoryId
              if(this.mode == 'create'){

                data.creater = this.userData.name + '(' + this.userData.account + ')';
              }
              data.updater = this.userData.name + '(' + this.userData.account + ')';
              materialSave(data).then(res => {
                if(res.code == 200){
                  this.$message.success('保存成功')
                  this.$emit('done',{type:'save'})
                  this.dialogVisible = false;
                }else{
                  this.$message.error(res.msg)
                }
              }).catch(err => {
                this.$message.error(err)
              })
            }
        })
      },

        closeDialog(){
            this.dialogVisible = false;
            this.$parent.createProductPanVisible = false;
        },
    }

}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        /* height:350px; */
        overflow-y: auto;
        overflow-x: hidden;
        /* padding: 0px 50px; */
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }

</style>



// WEBPACK FOOTER //
// src/views/basicData/materialList/createMaterialList.vue